import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryGrid() {
  return (
    <section className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20">
      <div className="text-center mb-12">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
          内容分类导航
        </h2>
        <p className="text-foreground-600 max-w-[500px] mx-auto">
          五大内容板块，覆盖一区二区全部核心领域，助您快速定位所需资源
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group bg-background-50 border border-background-200/70 rounded-lg p-6 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300"
          >
            <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-200 transition-colors">
              <i className={`${cat.icon} text-xl`}></i>
            </div>
            <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
              {cat.name}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-3">
              {cat.description}
            </p>
            <span className="text-xs text-foreground-400">
              {cat.articleCount} 篇文章
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}